<div mat-dialog-content >
  <div style="max-width: 100%" >
      <div  id="content" style="position: relative">

      </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()" color="accent">{{'general.annuler' | translate}}</button>
  <button mat-button (click)="valideFinancement()" color="primary">Valider ces paramètres</button>
</div>





